export default __webpack_public_path__ + "e52ca6a53e64c058407e5f10c8a32710.png";